import React, {useState}from 'react';
import { Container, Row, Col} from 'reactstrap';
import EllipsisTooltip from '../../../utils/EllipsisTooltip';

function TrackerInfo(props:any) {
  const [selectedRow, setSelectedRow] = useState(null);
  const [selectedColumn, setSelectedColumn] = useState(null);
  const [inDaysText, setInDaysText] = useState("(in days)");



  // Event handler to handle row selection
  const handleRowClick = ( rowIndex:any) => {
    setSelectedRow(prevRow => prevRow === rowIndex ? null : rowIndex);
    setSelectedColumn(null); // Clear selected column
  };  

  // Event handler to handle column selection
  const handleColumnClick = (columnIndex:any) => {
    setSelectedColumn(prevColumn => prevColumn === columnIndex ? null : columnIndex);
    setSelectedRow(null); // Clear selected row
  };
  const titles = props.trackers?.[0]?.titles? JSON.parse(props.trackers[0].titles): []; 
  const finalCalculations = props?.trackers?.[0]?.finalCalculations || [];
  const avgTitles = Object.values(finalCalculations)[0];
  const uiDisplayTitles:any = {
    "totalvalue":"Total Deal Value",
    "avgvalue":"Avg Deal Value",
    "avgdaysinstatus":"Avg Time in Status"
  }
   // Dynamic styles for header based on index
    // Function to determine if a row is selected
    const isRowSelected = (index: any) => {
      return selectedRow === index;
    };
      // Function to determine if a column is selected
  const isColumnSelected = (index: any) => {
    return selectedColumn === index;
  };
  return (
    <>
  

    <Container className="trackerContainer" 
    style={props?.trackersList?.find((tracker:any)=>tracker?.tracker_master_id === props?.trackerId)?.option_text === "Relationships"?
      {display:'block',backgroundColor:"#fff",width:"550px",height:"260px",paddingRight:"20px"}:
      {display:'block',backgroundColor:"#fff",width:"550px",paddingRight:"20px"}}>
    <div className= 'header-table'>
      {props?.trackersList?.find((tracker:any)=>tracker?.tracker_master_id === props?.trackerId)?.option_text === "Relationships"?
      <>
        {props.trackers?.[0]?.tableheader} <span className='inDaysText'>{inDaysText}</span>
       </>
      : props.trackers?.[0]?.tableheader}</div>
      {props.trackers?.length?<>
      <Row>
        <Col xs='3'>
          <Row xs="1" className="trackerRow">
            <Col className='horizantalHeader'> &nbsp;</Col>
          </Row>
         { props.trackers?.map((tracker:any, index:number)=>(
          <Row key={`tracker-${index}`}  xs="1" className={`trackerRow ${isRowSelected(index) ? 'rowSelection' : ''}`}>
            <Col className={`trackerDataColumnVerticalHeader clickableHeader ${isRowSelected(index) ? 'selected firstPart' : ''}`} onClick={()=>handleRowClick(index)}>
              <span className={props?.trackersList?.find((tracker:any)=>tracker?.tracker_master_id === props?.trackerId)?.option_text === "Relationships"?'relationshipSpan': 'optiontext' }>{tracker?.productname}</span>
            </Col>
          </Row>
         )

         )}

         {
          avgTitles && Object.keys(avgTitles)?.map((key:any, index:number)=>(
             <Row xs="1"  key={`avgTitle-${index}`} className={`trackerRow2 row-${index} ${(selectedColumn || selectedRow)?'active':''}`}>
              <Col className={`trackerDataColumnVerticalHeader clickableHeader ${isRowSelected(index+props.trackers?.length) ? 'selected' : ''}`} onClick={()=>handleRowClick(index +(props.trackers?.length||0))}>
                <span className={
                  uiDisplayTitles[key] == "Total Deal Value" ||
                  uiDisplayTitles[key] == "Avg Deal Value" ||
                  uiDisplayTitles[key] == "Avg Time in Status" 
                   ?'totalValues':''}>{uiDisplayTitles[key] || key}</span>
              </Col>
             </Row>
           )
         )}

        </Col>
        <Col xs='9'>
      <Row xs={(titles.length)} className="trackerRow">
        {/* <Col></Col> */}
        {
          titles.map((title:any, index:any)=>
            (<Col className= {`horizantalHeader clickable ${isColumnSelected(index) ? 'selected' : ''}`}  onClick={()=>handleColumnClick(index)}>{title.titlename}</Col>)
          )
        }
      </Row>

      {
       props.trackers?.length &&  props.trackers?.map((tracker:any, index:any)=>{
        const t= JSON.parse(tracker.titles);
        return (
        <Row xs={(t?.length)}  className="trackerRow notclick">

          {/* <Col className='verticalHeader'>{tracker?.productname}</Col> */}
          {
          t.map((title:any, colIndex:any)=>            
            <Col onClick={()=>handleColumnClick(index)} className={`trackerDataColumn 
            ${colIndex ==0 ? 'firstRow': ''}
            ${index===selectedRow?'activeRow':''} 
            ${colIndex===selectedColumn?'activeColumn':''} f-column-
            ${index} noData
            ${Math.floor(title.count)}`
          }><span>{Math.floor(title.count)}</span></Col>
          )
        }

        </Row>)})
      }

      {
       avgTitles &&  Object.keys(avgTitles)?.map((key:any, index:any)=>(
        <Row xs={(titles.length)}  className={`trackerRow2 notclick  row-${index}  ${(selectedColumn || selectedRow)?'active':''}`}>

          {/* <Col className='verticalHeader'>{uiDisplayTitles[key] || key}</Col> */}
          {
          titles.map((title:any, colIndex:any)=>            
            <Col onClick={()=>handleColumnClick(colIndex)} className={`totalDataColumn
            ${colIndex == 0 && (index+props.trackers?.length)===selectedRow?'firstElement':''}  
            ${(index+props.trackers?.length)===selectedRow? 'activeRow':''} 
            ${colIndex===selectedColumn?'activeColumn':''} f-column-
            ${index} noData${(props.trackers[0].finalCalculations[title.titlename][key] || 0)}`}>
              <span>
              <EllipsisTooltip
                      text={
                        (props.trackers[0].finalCalculations[title.titlename][key] || '0')
                      }
                      maxLine={6}
                    ></EllipsisTooltip>
              </span></Col>
          )
        }

        </Row>))
      }
      </Col>
      </Row>
      </>:"No Data available"} 
    </Container>
    
    </>
  )
}

export default TrackerInfo